let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cNb6z")).then(() => parcelRequire('2V5gE'));